import { render } from "./designAttachmentPreview.vue?vue&type=template&id=01fced01&scoped=true"
import script from "./designAttachmentPreview.vue?vue&type=script&lang=js"
export * from "./designAttachmentPreview.vue?vue&type=script&lang=js"

import "./designAttachmentPreview.vue?vue&type=style&index=0&id=01fced01&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01fced01"]])

export default __exports__